import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardSalesPlanRoutes = [
	{
		key: "reward-sales-plan",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/sales-plan`,
		component: React.lazy(() => import("views/reward-views/sales-plan/pages/SalesPlanSetup")),
	},
	{
		key: "reward-sales-plan-achievement",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/sales-plan/achievement`,
		component: React.lazy(() => import("views/reward-views/sales-plan/pages/DailyAchievement")),
	},
	{
		key: "reward-sales-plan-metrics",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/sales-plan/metrics`,
		component: React.lazy(() => import("views/reward-views/sales-plan/pages/MetricConfig")),
	},
];
